// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import MapFieldsToBottlebooks from '../../../../components/MapFieldsToBottlebooks/MapFieldsToBottlebooks';
import { bottlebooksFieldsSource, ProgressIndicator, useLink } from './_config';

import { useMapFieldsToBottlebooks } from '../../../../components/MapFieldsToBottlebooks/MapFieldsToBottlebooks';

export default function MapFieldsPage({ match }) {
  const link = useLink('mapFields');
  const history = useHistory();

  const props = useMapFieldsToBottlebooks({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
    bottlebooksFieldsSource,
    objectType: 'product',
  });

  return (
    <Layout>
      <ProgressIndicator step="mapData" />
      <PageHeader>
        <PageTitle>
          <Trans>Map field names</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Indicate which column contains information to import.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <MapFieldsToBottlebooks {...props} />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateColumnsMapping();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}
